import { makeStyles } from 'tss-react/mui';

export const useProductDetailsHeaderTagsStyles = makeStyles()((theme) => ({
  container: {
    marginBlock: theme.spacing(-0.5),
    marginLeft: theme.spacing(-0.75),
    '& > *': {
      display: 'flex',
    },
  },
  tag: {
    textTransform: 'lowercase',
    cursor: 'default',
  },
}));
